import '../partials/bootstrap'
import '../vendor/cookies';
import '../controllers/date_range_picker_controller'
import '../controllers/attendance_picker_controller';
import '../controllers/search_with_suggestions_date_controller'